





































































































































import { inPlugin } from "@/utils/base"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { downloadLog } from "@/utils/log"
@Component({
  name: "downloadDialog"
})
export default class downloadDialog extends Vue {
  // 通用弹窗的JS数据和方法
  cancel() {
    this.isSubmit = false
    this.dialogVisible = false
  }

  onSubmit() {
    this.isSubmit = true
    this.dialogVisible = false
  }

  dialogDataPresets = {
    game_name: "",
    game_icon: "",
    download_link: "",
    from: ""
  }

  get hadGame() {
    return !!this.dialogDataPresets.game_name
  }

  isRender: boolean = true
  isSubmit: boolean = false
  auto_download_link: string = ""

  @Prop()
  dialogVisible: boolean = false

  handleDownload() {
    let url =
      this.auto_download_link || "https://download.ghzs.com/ghzs?channel=GH_112"
    if (!this.auto_download_link) {
      //预约触发自动下载时，不上报
      downloadLog(
        this.dialogDataPresets.from === "wechat_appointment"
          ? "微信跳转"
          : "其他"
      )
    }
    if (inPlugin()) {
      if (window.Java && window.Java.openInExternalApp) {
        window.Java.openInExternalApp(url)
      }
      this.onSubmit()
      return
    }
    window.open(url, "_blank")
    this.onSubmit()
  }

  @Watch("dialogVisible")
  onShow(show) {
    if (show) {
      if (this.dialogDataPresets.download_link) {
        this.auto_download_link = this.dialogDataPresets.download_link
        this.handleDownload()
      }
      if (window._launchAppUrl) {
        if (window.GhzsUa.UA.Wechat) {
          setTimeout(() => {
            const btn = document.querySelector<HTMLElement>("#launch-btn")
            if (btn) {
              var ev = document.createEvent("Event")
              // @ts-ignore
              ev.initEvent("launch", true, true)
              btn.dispatchEvent(ev)
            }
          }, 100)
        } else if (window.GhzsUa.UA.Android) {
          window.open(window._launchAppUrl, "_blank")
        }
      }
    } else {
      this.auto_download_link = ""
    }
  }
}
